import { Link, NavLink, useLocation } from "react-router-dom";

export default function ProjectFacilitatorNavigation({ slug, showCohortResults = false }) {
  const { pathname } = useLocation();
  const membersPath = `/app/facilitate/project/${slug}/members`;
  const memberDetailPath = `/app/facilitate/project/${slug}/member/`;
  const membersActive = pathname === membersPath || pathname.startsWith(memberDetailPath);

  return (
    <nav aria-label="Project facilitation" className="av-project-facilitator-nav">
      <NavLink end to={`/app/facilitate/project/${slug}`}>Overview</NavLink>
      <Link
        aria-current={membersActive ? "page" : undefined}
        className={membersActive ? "active" : undefined}
        to={membersPath}
      >
        Members
      </Link>
      {showCohortResults ? <><NavLink to={`/app/facilitate/project/${slug}/cohort-results`}>Cohort evidence</NavLink><NavLink to={`/app/facilitate/project/${slug}/exports`}>Exports</NavLink></> : null}
    </nav>
  );
}
